import { FaTiktok } from "react-icons/fa";

function Footer() {
  return (
    <div>
      <div class="footer wow fadeIn" data-wow-delay="0.3s">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-lg-3">
              <div class="footer-contact">
                <h2>Get in touch</h2>
                <p>
                  <i class="fa fa-map-marker-alt"></i>Right Cash 421 High
                  Street,Chatham, Kent,ME4 4NU, (On the roundabout opposite
                  Luton Arches)
                </p>
                <p>
                  <i class="fa fa-phone-alt"></i>01634 830987
                </p>
                <p>
                  <i class="fa fa-envelope"></i>chatham@rightcash.co.uk
                </p>
                <p>
                  <a
                    href="https://api.whatsapp.com/send?phone=447871092759"
                    className="complaint-link-schedule"
                  >
                    WHATSAPP
                  </a>{" "}
                </p>
                <div class="footer-social">
                  <a href="https://www.facebook.com/RightCashPawnbrokers/">
                    <i class="fab fa-facebook-f"></i>
                  </a>
                  <a href="https://www.tiktok.com/@rightcashchatham">
                    <FaTiktok color="#ffffff" />
                  </a>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="footer-link">
                <h2>Our Services</h2>
                <a href="/instant-cash">Instant Cash</a>
                <a href="/buybacks">Buybacks</a>
                <a href="/pawn-broking">Pawnbroking</a>
                <a href="/we-sell">We Sell</a>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="footer-link">
                <h2>Useful Pages</h2>
                <a href="/contact">Contact Us</a>
                <a href="/privacy-policy">Privacy policy</a>
              </div>
            </div>
            <div class="col-md-6 col-lg-3">
              <div class="newsletter">
                <h2>Right Cash Ltd</h2>
                <p className="company-desc-schedule small-text">
                  Right Cash Ltd is Authorised and regulated by the
                  <strong> Financial Conduct Authority</strong> for consumer
                  credit activities.
                </p>
                <p className="company-desc-schedule small-text">
                  Members of the{" "}
                  <strong>National Pawnbrokers Association</strong>
                </p>
                <p className="complaint-text-schedule small-text">
                  Have a complaint or dispute regarding our pawnbroking service?
                </p>
                <a
                  href="/pawnbroking-complaints-handling-procedure"
                  className="complaint-link-schedule"
                >
                  CLICK HERE FOR MORE INFO
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="container footer-menu">
          <div class="f-menu">
            <a href="/privacy-policy">Privacy policy</a>
          </div>
        </div>
        <div class="container copyright">
          <div class="row">
            <div class="col-md-6">
              <p>
                &copy; <a href="#">RightCash</a>, All Right Reserved.
              </p>
            </div>
            <div class="col-md-6">
              <p>
                Developed By{" "}
                <a href="https://checkmatetechnologies.net">
                  Checkmate Technologies
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
